declare var window: any;

class url {
	private _url: string;
	private _params: string;

	constructor(address) {
		this._url = address;
		this._params = "";
	}


	url() {
		return this._url;
	}

	params() {
		return this._params;
	}

	addParam(paramName, paramValue) {
		if (this._params.length !== 0) {
			this._params += "&";
		}

		this._params += encodeURIComponent(paramName) + "=" + encodeURIComponent(paramValue);
	}

	getFullUrl() {
		if (this._params.length > 0) {
			if (this._url.indexOf('?') > 0)
				return this._url + '&' + this._params;
			else
				return this._url + '?' + this._params;
		} else
			return this._url;
	}
}

export class UrlHelper {
	iterateParams(params, func) {
		if ((typeof params) === 'string') {
			let arrParamValues = params.split('&');
			for (const keyvalue of arrParamValues) {
				const split = keyvalue.split('=');
				func(split[0], split[1]);
			}
			return
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const item = params[key];

				if (Array.isArray(item)) {
					for (const subItem of item) {
						func(key, subItem);
					}
				}
				else if (item && (typeof item) === "object" && (typeof item.name) !== "undefined") {
					func(item.name, item.value);
				}
				else {
					func(key, item)
				}

			}
		}
	}

	makeUrl(in_url: string, params: any, withoutObligatory?: boolean) {
		let retUrl = new url(in_url)

		if (!withoutObligatory) {
			let vers = this.getVer();
			retUrl.addParam('ver', vers);

			if ((typeof window.appContext) !== "undefined" && window.appContext.at) {
				retUrl.addParam('at', window.appContext.at);
			}
			else if ((typeof window.strATTok) !== "undefined") {
				retUrl.addParam('at', window.strATTok);
			}
		}

		this.iterateParams(params, (name, value) => retUrl.addParam(name, value));

		return retUrl.getFullUrl();
	}

	getParameterByName(name, url) {
		if (!url) {
			url = window.location.href
		}
		name = name.replace(/[\[\]]/g, "\\$&")

		let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
		let results = regex.exec(url)

		if (!results)
			return null;

		if (!results[2])
			return ''

		let value = results[2].replace(/\+/g, " ");
		return decodeURIComponent(value);
	}

	getParameters(url: string) {
		let startQuery = url.indexOf("?");
		if (startQuery == -1) {
			return {};
		}
		let query = url.substring(startQuery + 1)

		return query
			? (/^[?#]/.test(query) ? query.slice(1) : query)
				.split('&')
				.reduce((params, param) => {
					let [key, value] = param.split('=');
					params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
					return params;
				}, {}
				)
			: {}
	}

	getVer() { var d; d = new Date(); return d.getTime(); }
}

export const UrlHelperInstance = new UrlHelper();
